import { Text } from "@clipboard-health/ui-components";
import { Box, Divider, Stack } from "@mui/material";

import { getTaxPreparationSteps } from "../utils/getTaxPreparationSteps";
import { TaxPreparationStep } from "./TaxPreparationStep";

export function TaxPreparationSection(props: { taxationYear: number }) {
  const { taxationYear } = props;

  const taxPreparationStepsContent = getTaxPreparationSteps({ taxationYear });

  return (
    <Box>
      <Stack direction="row">
        <Text semibold variant="h5">
          Prepare for Tax Season
        </Text>
      </Stack>
      <Stack direction="column" sx={{ marginTop: 6 }}>
        {taxPreparationStepsContent.map((step, stepIndex) => (
          <Box key={step.title}>
            <TaxPreparationStep {...step} />
            {stepIndex < taxPreparationStepsContent.length - 1 && <Divider sx={{ my: 5 }} />}
          </Box>
        ))}
      </Stack>
    </Box>
  );
}
